module.exports = __webpack_public_path__ + "img/fresher-tastier.a93a61d4.jpg";